/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-return-assign */
import axios from "axios";

// Constants
import { BASE_URL, URL } from "../constants/api-constants";
import ROUTE from "../constants/route-constants";
import { UNKNOWN_ERROR } from "../constants/common";

// Utils
import {
  cleanUserTokensFromLocalStorage,
  getAccessToken,
  getRefreshToken,
  getSessionToken,
  setUserTokensToLocalStorage,
} from "../utils/user";

const baseURL = BASE_URL;

const http = axios.create({
  baseURL,
  headers: {
    "Cache-Control": "no-cache, no-store",
    Pragma: "no-cache",
    Expires: "0",
  },
});

http.interceptors.request.use(
  async (config) => {
    const accessToken = getAccessToken();
    const sessionToken = getSessionToken();

    if (accessToken) {
      config.headers?.set("Authorization", `Bearer ${accessToken}`);
      config.headers?.set("Session", `Bearer ${sessionToken}`);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const errorMessage = error?.response?.data?.message ?? UNKNOWN_ERROR;

    if (error?.response?.status === 401) {
      try {
        const refreshToken = getRefreshToken();

        if (!refreshToken && window.location.pathname !== ROUTE.AUTH_SIGN_IN) {
          return (window.location.href = ROUTE.AUTH_SIGN_IN);
        }

        if (!refreshToken && window.location.pathname === ROUTE.AUTH_SIGN_IN) {
          throw new Error(errorMessage);
        }

        const response = await http.post(`${baseURL}/${URL.REFRESH_TOKEN_URL}`, {
          refreshToken,
        });

        const { access_token, session_token } = response.data;

        const refresh_token = refreshToken as string;
        setUserTokensToLocalStorage(access_token, refresh_token, session_token);
        error.config.headers = {
          ...error.config.headers,
          Authorization: `Bearer ${access_token}`,
          Session: `Bearer ${session_token}`,
        };

        return await http.request(error.config);
      } catch {
        cleanUserTokensFromLocalStorage();

        if (window.location.pathname !== ROUTE.AUTH_SIGN_IN) {
          return (window.location.href = ROUTE.AUTH_SIGN_IN);
        }
      }
    }

    if (error?.response?.status === 403) {
      return (window.location.href = ROUTE.HOME);
    }

    throw new Error(errorMessage);
  }
);

export default http;
